var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent'),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('NavigationComponent')],1),_c('b-col',{attrs:{"md":"9"}},[_c('router-view')],1)],1)],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }